import React from 'react';
import styled from 'styled-components';
import { getMargins } from '../lib/helpers';
import { Box as B, Flex } from './../components/layout/Grid';
import BaseSkeleton from './BaseSkeleton';
import BlogCardSkeleton from './BlogCardSkeleton';
import VideoCardSkeleton from './VideoCardSkeleton';

const Box = styled(B)`
  @media (max-width: ${props => `${props.theme.viewports.tablet}px`}) {
    min-width: ${props => (props.overviewsection ? '407px' : null)};
    min-width: ${props => (props.overviewblogsection ? '300px' : null)};
  }
  @media (max-width: ${props => `${props.theme.viewports.mobile}px`}) {
    min-width: ${props => (props.overviewsection ? '300px' : null)};
  }
`;

const CardRowSkeleton = props => (
  <Box style={{ overflow: 'hidden' }}>
    <B mb={20}>
      <BaseSkeleton
        shape={'square'}
        height={30}
        width={40}
        animation={props.animation}
      />
    </B>
    <B>
      <Flex px={0} ml={[-10, -10, -15]} mr={[-10, -10, -15]}>
        {props.overviewsection &&
          props.items.map((item, index) => (
            <Box
              overviewsection={props.overviewsection}
              key={index}
              width={props.width ? props.width : [1, 1 / props.items.length]}
              {...getMargins(
                index,
                props.margin ? props.margin : props.items.length,
                props.margin ? props.margin : null
              )}
              pr={0}
              pl={0}
              px={0}
              mx={[10, 10, 15]}
            >
              <VideoCardSkeleton animation={props.animation} />
            </Box>
          ))}
        {props.overviewblogsection &&
          props.items.map((item, index) => (
            <Box
              overviewblogsection={props.overviewblogsection}
              key={index}
              width={props.width ? props.width : [1, 1 / props.items.length]}
              {...getMargins(
                index,
                props.margin ? props.margin : props.items.length,
                props.margin ? props.margin : null
              )}
              pr={0}
              pl={0}
              px={0}
              mx={[10, 10, 15]}
            >
              <BlogCardSkeleton animation={props.animation} />
            </Box>
          ))}
      </Flex>
    </B>
  </Box>
);

export default CardRowSkeleton;
